import type { InstanceDetail, TemplateDetail } from '@/lib/scientific'
import { WorkspaceFiles } from './WorkspaceFiles'
import { TaskRubric } from './TaskRubric'
import { WorkflowRubric } from './WorkflowRubric'
import { WorkflowHistory } from './WorkflowHistory'
import { WorkflowInstructions } from './WorkflowInstructions'

export function WorkflowMaterials({ developer, tab, data, current, selected, base, onSelect }: {
  developer: boolean; tab: string; data: TemplateDetail; current: InstanceDetail | null; selected: string; base: string; onSelect: (id: string, tab?: string) => void
}) {
  const { definition, template } = data
  const scope = !selected
  const environment = current?.environment ?? definition.environment
  const pick = <p className="muted small">Each task has its own {tab === 'rubric' ? 'rubric' : 'files'}. Select a task above to review them.</p>
  return <>
    {tab === 'prompt' && <WorkflowInstructions data={data} current={current} selected={selected} onSelect={id => onSelect(id, 'prompt')} />}
    {tab === 'rubric' && <section className="box science-document"><h2>{scope ? 'Workflow rubric' : 'Task rubric'}</h2>
      {scope ? <WorkflowRubric data={data} onSelect={id => onSelect(id, 'rubric')} /> : current && <TaskRubric spec={current.rubric_map} developer={developer} />}
    </section>}
    {tab === 'files' && <section className="box science-document">
      {scope ? <><h2>Agent workspace</h2>{pick}</>
        : current && <WorkspaceFiles key={`${selected}:${current.material_digest}`} base={`${base}/tasks/${selected}`} revision={current.revision_id} files={[...current.files, ...(current.runtime_files ?? [])]} />}
    </section>}
    {tab === 'programs' && <section className="box science-document"><h2>Rollout environment</h2>
      <h3>Available applications</h3>
      {environment.error && <p className="note err">{environment.error}</p>}
      {environment.applications?.length ? <dl className="science-field-list">{environment.applications.map(app => <div key={app.name}><dt>{app.name}</dt><dd>{app.version}</dd></div>)}</dl> : <p className="muted">{developer ? 'This pinned catalog does not provide a software inventory. Re-import after its inventory is available.' : 'The software inventory is unavailable.'}</p>}
      {environment.os && <p>{environment.os} · {environment.architecture}</p>}
      {developer && <p className="muted small">Versions declared by the pinned image. Files and capabilities remain tied to the reviewed revision.</p>}
      {developer && <section className="science-parameters"><h3>Image & source revision</h3><dl>
        <div><dt>Workflow</dt><dd>{template.collection.template_id} · v{template.collection.version}</dd></div>
        <div><dt>Image</dt><dd><code>{environment.image_release}</code></dd></div>
        <div><dt>Code hash</dt><dd><code>{template.collection.code_sha256}</code></dd></div>
        <div><dt>Pull request</dt><dd>#{template.collection.pull_request} at <code>{template.collection.commit}</code></dd></div>
      </dl></section>}
    </section>}
    {developer && ['changes', 'history'].includes(tab) && <WorkflowHistory key={`${selected}:${tab}`} data={data} selected={selected} changesOnly={tab === 'changes'} />}
  </>
}
